var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAndroid = function SvgIcAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_android_svg__ic_android",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ic_android_svg__cls-1{fill:rgba(0,20,40,0.38)}.ic_android_svg__cls-2{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_android_svg__Group_452",
    "data-name": "Group 452",
    transform: "translate(2.667 0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_android_svg__Path_9609",
    "data-name": "Path 9609",
    className: "ic_android_svg__cls-1",
    d: "M2.533,11.33A1.821,1.821,0,0,1,4,10.8a2.005,2.005,0,0,1,1.467.533A1.821,1.821,0,0,1,6,12.8V22.13A2.005,2.005,0,0,1,5.467,23.6,1.821,1.821,0,0,1,4,24.13,2.005,2.005,0,0,1,2.533,23.6,2.221,2.221,0,0,1,2,22.13V12.8A1.821,1.821,0,0,1,2.533,11.33ZM20,2.93a7.4,7.4,0,0,1,3.333,6.4h-16a7.4,7.4,0,0,1,3.333-6.4L8.8,1.2C8.4.93,8.4.663,8.8.263a.558.558,0,0,1,.933,0l2,2a6.919,6.919,0,0,1,3.6-.933,6.919,6.919,0,0,1,3.6.933l2-2a.644.644,0,0,1,.933,0,.644.644,0,0,1,0,.933ZM7.333,24V10.663h16V24A1.367,1.367,0,0,1,22,25.33H20.667V30a2,2,0,1,1-4,0V25.33H14V30a2,2,0,1,1-4,0V25.33H8.667a1.21,1.21,0,0,1-.933-.4A1.21,1.21,0,0,1,7.333,24ZM12.667,6.663V5.33H11.333V6.663Zm6.667,0V5.33H18V6.663ZM25.2,11.33a1.821,1.821,0,0,1,1.467-.533,1.845,1.845,0,0,1,2,2V22.13a2,2,0,1,1-4,0V12.8A1.821,1.821,0,0,1,25.2,11.33Z",
    transform: "translate(-2 -0.011)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ic_android_svg__Rectangle_401",
    "data-name": "Rectangle 401",
    className: "ic_android_svg__cls-2",
    width: 32,
    height: 32
  })));
};
export default SvgIcAndroid;